import { TherapistAction } from 'src/redux/actions/constant';

const intialState: object = {
  response: null,
  isTimeBasisUpdated: false,
  loading: false,
};

export const updateTimeBasisReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.UPDATE_TIME_BASIS_SUCCESS:
      return {
        ...state,
        response: action.payload,
        isTimeBasisUpdated: true,
        loading: false,
      };

    case TherapistAction.UPDATE_TIME_BASIS_FAILURE:
      return {
        ...state,
        response: action.payload,
        isTimeBasisUpdated: false,
        loading: false,
      };

    case TherapistAction.UPDATE_TIME_BASIS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case TherapistAction.UPDATE_TIME_BASIS_RESET:
      return intialState;

    default:
      return state;
  }
};
